import Image from 'next/image'
import 'swiper/css'
import 'swiper/css/pagination'
import { Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import styles from './Testimonials.module.scss'

function resolveHeadshot(headshot) {
  if (!headshot) return { src: '/silhouette.svg', alt: 'Silhouette placeholder' }
  if (typeof headshot === 'string') return { src: headshot, alt: '' }
  return { src: headshot.sourceUrl || '/silhouette.svg', alt: headshot.altText || '' }
}

export default function Testimonials({ testimonials = [] }) {
  if (!testimonials.length) return null

  const showDots = testimonials.length > 1

  return (
    <section className={styles.testimonials}>
      <Image className={styles.quoteMark} src="/testimonial-quote-mark.svg" alt="" aria-hidden="true" width={452} height={338} />

      <Swiper
        className={styles.swiper}
        slidesPerView={1}
        autoHeight={true}
        speed={600}
        loop={showDots}
        pagination={showDots ? { clickable: true } : false}
        modules={[Pagination]}
      >
        {testimonials.map((testimonial, index) => {
          const { src, alt } = resolveHeadshot(testimonial.headshot)
          const attribution = [testimonial.name, testimonial.title].filter(Boolean).join(', ')
          return (
            <SwiperSlide key={index} className={styles.slide}>
              <Image
                className={styles.headshot}
                src={src}
                alt={alt || testimonial.name || 'Testimonial headshot'}
                width={127}
                height={127}
                sizes="127px"
              />
              <blockquote className={styles.quote}>
                <span dangerouslySetInnerHTML={{ __html: testimonial.quote }} />
                {attribution && <footer className={styles.attribution}>&ndash;{attribution}</footer>}
              </blockquote>
            </SwiperSlide>
          )
        })}
      </Swiper>
    </section>
  )
}
